module.exports = __webpack_public_path__ + "c1ab629e4086eea4b274ed165724c00d.png";